export const fuelTypeOptions = {
  propane: 'Propane',
  diesel: 'Diesel',
  electric: 'Electric',
  naturalGas: 'Natural Gas',
  other: 'Other engine type (please specify)'
};

export const equipmentTypes = {
  irrigationEngine: 'irrigation engine',
  buildingHeat: 'building heater',
  waterHeating: 'water heater',
  powerGenerator: 'power generator'
};

export const otherPropaneFueledProducts = {
  none: 'N/A -- I do not own other propane-fueled products or appliances',
  cogeneration: 'Cogeneration (combined heat and power) unit',
  cookstove: 'Cookstove',
  fireplace: 'Fireplace',
  forklift: 'Forklift',
  furnace: 'Furnace',
  generator: 'Generator set',
  grainDryer: 'Grain dryer',
  grill: 'Grill (outdoor)',
  indoorSpaceHeater: 'Indoor space heater (greenhouse/livestock building/shop)',
  mower: 'Mower',
  outdoorSpaceHeater: 'Outdoor space heater',
  oven: 'Oven',
  tractor: 'Tractor',
  vehicle: 'Vehicle',
  waterHeater: 'Water heater (storage tank)',
  tanklessWaterHeater: 'Water heater (tankless)',
  other: 'Other (please specify)'
};

export const topInformationSources = {
  equipmentDealer: 'Equipment dealer',
  farmShows: 'Farm shows and demonstrations',
  friends: 'Friends or neighbors',
  internet: 'Internet searches',
  localProfessionals:
    'Local professionals (service providers, extension agents)',
  magazines: 'Magazines or newspapers',
  propaneDealer: 'Propane dealer',
  salesReps: 'Product sales representatives',
  radio: 'Radio',
  tv: 'Television',
  other: 'Other (please specify)'
};

export const monthsToBuy = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const consideredPowerSourcesChoices = {
  none: 'None - only propane',
  diesel: 'Diesel-fueled engine',
  electric: 'Electric motor',
  naturalGas: 'Natural Gas fueled engine',
  other: 'Other (please specify)'
};

export const whyChoosePropaneChoices = {
  availability: 'Availability',
  capital: 'Capital costs',
  ease: 'Ease of refueling',
  environmental: 'Environmental friendliness',
  incentives: 'Grant or tax incentive(s) (excludes PERC Incentive)',
  maintenance: 'Maintenance',
  costs: 'Operating costs',
  reliability: 'Reliability (of fuel)',
  service: 'Service',
  american: 'Uses an American-made fuel',
  other: 'Other (please specify)'
};

export const decisionMakerChoices = {
  me: 'I was the final decision maker',
  partOfGroup: 'I was part of a small group that made the decision',
  helped: 'I helped in the process but was not part of the final decision',
  notInvolved: 'I was not involved'
};
